import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const stuffRuleList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuffPoints/list?` + params,
        method: 'GET'
    })
}

export const editStuffRule = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuffPoints/updatePoints`,
        method: 'PUT',
        data: params
    })
}
export const pointsDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/departmentPoints/pointsDetail/${id}`,
        method: 'GET'
    })
}